module.exports = __webpack_public_path__ + "img/emoji.01d7169b.png";